import axios, { AxiosInstance } from "axios";
import { Constructor } from "@/typing";
import { Class } from "type-fest";
export function UsesAxios<TBase extends Constructor>(
  Base: TBase
): Class<HttpService> {
  return class UsingAxios extends Base implements BindableHttpClient {
    _httpClient: AxiosInstance = axios;

    setHttpClient(client: AxiosInstance): this {
      this._httpClient = client;
      return this;
    }

    get httpClient(): AxiosInstance {
      return this._httpClient;
    }
  };
}

export interface BindableHttpClient {
  setHttpClient(client: AxiosInstance): this;
}
interface HttpService extends BindableHttpClient {
  httpClient: AxiosInstance;
}
const HttpServiceBaseClass = class HttpServiceBase {};

export default UsesAxios(HttpServiceBaseClass);
